import { luscinia } from "../luscinia";
import { Bootgrid } from "./bootgrid";
import { BootgridManager } from "./bootgridManager";
import ParameterBootgrid from "./parameter-bootgrid";
import initRecordPageBootgrids from "./init-record-page-bootgrids";

luscinia.initBootgrids = async function (config) {
    initParameterBootgrids(config);
    const bootgridElements = $(`.${luscinia.css.bootgrid}`);
    if (isRecordPage(bootgridElements) && !document.querySelector(".page-head .view-manager") && !isWizardPage()) {
        initRecordPageBootgrids(bootgridElements, config);
    } else {
        initOtherBootgrids(bootgridElements, config);
    }
};

function initParameterBootgrids(config: Config) {
    const parameterBootgrids = document.querySelectorAll('table[data-parameterbootgrid="true"]') as NodeListOf<HTMLTableElement>;
    parameterBootgrids.forEach((element) => {
        if ($(element).attr("bootgrid-initialized") === "true") return;
        $(element).attr("bootgrid-initialized", "true");
        new ParameterBootgrid(config, element).init();
    });
}

function initOtherBootgrids(bootgridElements: JQuery<HTMLElement>, config: Config) {
    let bootgrids: Bootgrid[] = [];
    if (bootgridElements.length === 0) return;
    bootgridElements.each((index, element) => {
        if ($(element).attr("bootgrid-initialized") === "true") return;
        $(element).attr("bootgrid-initialized", "true");

        const bootgrid = new Bootgrid(config, $(element));
        bootgrids.push(bootgrid);
    });
    const bootgridManager = new BootgridManager(bootgrids);

    bootgrids.forEach((bootgrid) => {
        bootgrid.bootgridManager = bootgridManager;
        bootgrid.init();
    });
}

function isRecordPage(bootgridElements: JQuery<HTMLElement>) {
    return !bootgridElements.eq(0).data(luscinia.bootgrid.data.inRecordView) && $("#wizard").length === 0;
}

function isWizardPage(): boolean {
    return $("#pcont #wizardcontainer").length > 0;
}
